import { render, staticRenderFns } from "./dome.vue?vue&type=template&id=facdaccc&scoped=true&"
import script from "./dome.vue?vue&type=script&lang=js&"
export * from "./dome.vue?vue&type=script&lang=js&"
import style0 from "./dome.vue?vue&type=style&index=0&id=facdaccc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "facdaccc",
  null
  
)

export default component.exports